import styled from "styled-components";

const getPath = (fileName: string) => `/static/img/rebrand/svgs/environments/${fileName}.svg`;

export const Forest = () => <IMG src={getPath("HeroForest")} alt="Forest" />;
export const OceanWaves = () => <IMG src={getPath("OceanWaves")} alt="Ocean waves" />;
export const Desert = () => <IMG src={getPath("Desert")} alt="Desert" />;
export const Mountains = () => <IMG src={getPath("Mountains")} alt="Mountains" />;
export const OurStoryEnvironment = () => (
  <IMG src={getPath("OurStory")} alt="Desert, ocean waves and mountain range" />
);
export const OurTeamEnvironment = () => (
  <IMG src={getPath("OurTeam")} alt="Mountain range, desert and forest" />
);
export const PressEnvironment = () => <IMG src={getPath("Press")} alt="Forest" />;
export const Oceans = () => <IMG src={getPath("Oceans")} alt="Oceans" />;
export const FourWorlds = () => (
  <IMG src={getPath("FourWorlds")} alt="Forest, desert, ocean waves and mountain range" />
);

interface ImgProps {
  zIndex?: number;
}

const IMG = styled.img<ImgProps>`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  max-width: unset;
  z-index: ${(p) => (p.zIndex ? p.zIndex : "auto")};

  @media only screen and (max-width: 52rem) {
    width: 200%;
  }

  @media only screen and (max-width: 30rem) {
    width: 300%;
  }
`;
